import React from 'react'
import { Banner, Category } from '../components';


function Home() {
    return (
        <div>
            <Banner />
            <Category />
        </div>
    );
}

export { Home };
